import { useAuth } from '@/contexts/AuthContext';
import { setLaeknanumer } from '@/lib/authModeApi';
import { useMutation } from '@tanstack/react-query';

/** Save the doctor's læknanúmer once, then reload the user so hasLaeknanumer flips. */
export const useSetLaeknanumer = () => {
  const { refetch } = useAuth();
  return useMutation({
    mutationFn: setLaeknanumer,
    onSuccess: () => refetch(),
  });
};
